import { TOGGLE_SIDEBAR } from '../actions'

const sidebarToggleHandler = state => {
    return {...state, activeSidebar: !state.activeSidebar}
}

const LayoutReducer = (state, action) => {
    switch (action.type) {
        case TOGGLE_SIDEBAR:
            return sidebarToggleHandler(state)

        default:
            break;
    }
}

export default LayoutReducer